export var ModalType;
(function (ModalType) {
    ModalType["MAIN"] = "main";
    ModalType["SHARE"] = "share";
    ModalType["COPY"] = "copy";
    ModalType["EMAIL_EMBED"] = "emailEmbed";
    ModalType["SUBTITLES"] = "subtitles";
    ModalType["IVS_QUALITY"] = "ivsQuality";
})(ModalType || (ModalType = {}));
